// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"9450f0a8","453":"491244b9"}[chunkId] + ".chunk.js";
};